module.exports = __webpack_public_path__ + "hummingbird.jpg";